import { Fragment } from 'react';
import { makeStyles } from 'tss-react/mui';
import Paper from '@mui/material/Paper';

import MaterialLinkButton from '../material-link-button';
import SectionHeader from '../section-header';
import Post from './post';
import type { GroupPost } from '../../types/GroupPost';
import type { Group } from '../../types/Group';
import { momentParse } from '../../utils/time';

const useStyles = makeStyles()((theme) => ({
  paper: {
    padding: theme.spacing(2),
  },
  buttons: {
    marginTop: theme.spacing(2)
  },
}));

type Props = {
  post?: GroupPost;
  group?: Group;
};

const LatestGroupPost = ({ post, group }: Props) => {
  const { classes } = useStyles();

  if (!group.permissions.createPost) {
    return null;
  }

  return (
    <>
      <SectionHeader
        action={
          <MaterialLinkButton
            href={`/groups/${group.slug}/posts`}
            variant="outlined"
            size="small"
          >
            All Posts ({group.postsCount})
          </MaterialLinkButton>
        }
      >
        Recent Discussion
      </SectionHeader>
      {post && momentParse(post.createdAt).isAfter(momentParse().subtract(1, 'month')) ? (
        <Paper className={classes.paper}>
          <Post post={post} group={group} />
        </Paper>
      ) : (
        <Fragment>
          <p>
            No recent discussion. Have an announcement or want to start a discussion with members of the group?
          </p>
          <div className={classes.buttons}>
            <MaterialLinkButton
              href={`/groups/${group.slug}/posts/new`}
              variant="contained"
              color="primary"
            >
              Add Post
            </MaterialLinkButton>
          </div>
        </Fragment>
      )}
    </>
  );
};

export default LatestGroupPost;
